import { createSlice } from "@reduxjs/toolkit";

// Drives the Facebook-style comments bottom sheet (a single always-mounted
// <CommentsSheet/> at app root). Replies are shown inline (one level deep) — no
// separate thread screen. Opening the sheet never navigates, so the feed stays
// mounted behind it. `focusCommentId` lets a deep-link expand + scroll to a
// specific comment or reply.
const initialState = {
  isOpen: false,
  postGroup: null, // full post_group (carries group_id, post.id, comments_count)
  from_main_group: true,
  focusCommentId: null,
};

const commentsSheetSlice = createSlice({
  name: "commentsSheet",
  initialState,
  reducers: {
    openCommentsSheet: (state, action) => {
      const {
        postGroup,
        from_main_group = true,
        focusCommentId = null,
      } = action.payload || {};
      state.isOpen = true;
      state.postGroup = postGroup || null;
      state.from_main_group = from_main_group;
      state.focusCommentId = focusCommentId;
    },
    closeCommentsSheet: () => ({ ...initialState }),
    // Deep-link entry: open (or refocus) the sheet on a specific comment/reply.
    focusComment: (state, action) => {
      state.focusCommentId = action.payload?.commentId ?? null;
    },
    clearCommentFocus: (state) => {
      state.focusCommentId = null;
    },
  },
});

export const {
  openCommentsSheet,
  closeCommentsSheet,
  focusComment,
  clearCommentFocus,
} = commentsSheetSlice.actions;

export default commentsSheetSlice.reducer;
